import React from 'react';
import ListFiltersSourceBtn from './ListFiltersSourceBtn';
import {connect} from 'react-redux';

const SocialFilters = (props) => {
    const {socialFilters, toggleSocialFilters, activeView, updating, socialCount, activeEntity, auth, hideLabel} = props;
    return (
        <div className="home-page-filters__filter-container">
            {!hideLabel && <div style={{fontWeight: '700'}}>Source</div>}
            <div style={{display: 'flex', color: '#ffffff'}} className="home-page-filters__source-container home-page-filters__source-container--no-mb">
                <ListFiltersSourceBtn
                    iconClasses="fab fa-twitter"
                    handleSelect={() => toggleSocialFilters('twitter')}
                    backgroundColor="#1DA1F2"
                    socialFilters={socialFilters}
                    type="twitter"
                    name="Twitter"
                    activeEntity={activeEntity}
                    count={socialCount.twitter}
                    loading={updating}
                    activeView={activeView}
                    inHeader
                />
                <ListFiltersSourceBtn
                    iconClasses="fab fa-facebook-f"
                    handleSelect={() => toggleSocialFilters('facebook')}
                    backgroundColor="#4267B2"
                    socialFilters={socialFilters}
                    type="facebook"
                    name="Facebook"
                    activeEntity={activeEntity}
                    count={socialCount.facebook}
                    loading={updating}
                    activeView={activeView}
                    inHeader
                />
                <ListFiltersSourceBtn
                    iconClasses="fab fa-youtube"
                    handleSelect={() => toggleSocialFilters('youtube')}
                    backgroundColor="#FF0000"
                    socialFilters={socialFilters}
                    type="youtube"
                    name="YouTube"
                    activeEntity={activeEntity}
                    count={socialCount.youtube}
                    loading={updating}
                    activeView={activeView}
                    inHeader
                />
                <ListFiltersSourceBtn
                    iconClasses="fab fa-instagram"
                    handleSelect={() => toggleSocialFilters('instagram')}
                    socialFilters={socialFilters}
                    type="instagram"
                    name="Instagram"
                    activeEntity={activeEntity}
                    count={socialCount.instagram}
                    loading={updating}
                    activeView={activeView}
                    inHeader
                />
                <ListFiltersSourceBtn
                    iconClasses="fas fa-rss"
                    handleSelect={() => toggleSocialFilters('rss')}
                    backgroundColor="#ee802f"
                    socialFilters={socialFilters}
                    type="rss"
                    name="RSS"
                    activeEntity={activeEntity}
                    count={socialCount.rss}
                    loading={updating}
                    activeView={activeView}
                    inHeader
                />
                <ListFiltersSourceBtn
                    iconClasses="fa fa-globe"
                    handleSelect={() => toggleSocialFilters('google_ozmosys')}
                    backgroundColor="#314784"
                    socialFilters={socialFilters}
                    type="google_ozmosys"
                    name="Google News"
                    activeEntity={activeEntity}
                    count={socialCount.google_ozmosys}
                    loading={updating}
                    activeView={activeView}
                    inHeader
                />
                {auth.permissions && auth.permissions.includes('vs') &&
                <ListFiltersSourceBtn
                    iconClasses="fa fa-cog"
                    handleSelect={() => toggleSocialFilters('web')}
                    backgroundColor="#6E7179"
                    socialFilters={socialFilters}
                    type="web"
                    name="Feed Builder"
                    activeEntity={activeEntity}
                    count={socialCount.web}
                    loading={updating}
                    activeView={activeView}
                    inHeader
                />
                }
            </div>
        </div>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(SocialFilters);